import React, { useContext } from "react"
import { Button, Tabs, Box, Typography, Breadcrumbs } from "@material-ui/core"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"
import FiberManualRecordTwoToneIcon from "@material-ui/icons/FiberManualRecordTwoTone"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import moment from "moment"
import { useMemo } from "react"
import BillingContext from "../../../../pages/Shoot/pages/Billing/BillingContext"
import { useSelector, useDispatch } from "react-redux"
import { hasNotifications } from "../../../../utils/hasNotifications"
import { updateDealMemoBillingStep } from "../../../../actions/billing"

//Styles, ran into some erros with styles on seperate page, interferes with current logic needs work around
const CurrentPageStyle = {
  border: "2px solid rgba(65, 178, 91, 1)",
  boxShadow: "none",
  color: "rgba(34, 34, 34, 1)",
  borderRadius: 5,
  paddingLeft: 5,
  marginRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  background: "white",
  textTransform: "none",
  marginTop: "20px",
  marginBottom: "15px",
  minWidth: "115px",
  opacity: 1,
}
const AfterStyles = {
  border: "2px solid rgba(245, 245, 245, 1)",
  boxShadow: "none",
  color: "rgba(34, 34, 34, 1)",
  fontFamily: "Helvetica",
  borderRadius: 5,
  paddingLeft: 5,
  marginRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  background: "white",
  marginTop: "20px",
  marginBottom: "15px",
  textTransform: "none",
  minWidth: "115px",
  opacity: 1,
}

const PageBreadcrumbs = props => {
  const { currentShootData } = useContext(BillingContext)
  let shootId = props.match.params.shoot_id

  let dealMemoArray = [
    "Deal Memo",
    "Estimate",
    "Shoot",
    "Bill Approval",
    "Invoice",
    "Done",
  ]

  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)
  const generalData = useSelector(state => state.billing.generalData)
  const dispatch = useDispatch()

  let done = useMemo(
    () => {
      let stateArray = [false, false, false, false, false]
      let index = dealMemoArray.indexOf(
        generalData && generalData.billing_step_name
      )
      let newArray = stateArray.map((x, i) => {
        if (i < index) {
          return true
        } else {
          return false
        }
      })
      return newArray
    },
    [generalData]
  )

  const crewArray = useMemo(
    () => {
      let newArray = []
      if (usersRolesArray) {
        let data = usersRolesArray
        data.map(x => {
          x.expenses.map(y => {
            newArray = [...newArray, y.crew_flag_status]
          })
        })
      }

      return newArray
    },
    [usersRolesArray]
  )
  const clientArray = useMemo(
    () => {
      let newArray = []
      if (usersRolesArray) {
        let data = usersRolesArray
        data.forEach(x => {
          x.expenses.forEach(y => {
            newArray = [...newArray, y.client_flag_status]
          })
        })
      }

      return newArray
    },
    [usersRolesArray]
  )

  const invoiceArray = useMemo(
    () => {
      let newArray = []
      let additionalArray = []
      if (usersRolesArray) {
        let data = usersRolesArray
        data.forEach(x => {
          x.expenses.forEach(y => {
            newArray = [...newArray, y.client_flag_status]
          })
        })
        data.forEach(x => {
          x.additional_expenses.forEach(y => {
            additionalArray = [...additionalArray, y.client_flag_status]
          })
        })
      }

      return [...newArray, ...additionalArray]
    },
    [usersRolesArray]
  )

  const date = moment(currentShootData.start_date).format("M/D/YY")
  const shootDate = moment(currentShootData.start_date)
  const today = moment()
  let isTheShootToday = shootDate.isBefore(today, "day")

  const breadcrumbPaths = [
    {
      to: "/deal-memo",
      label: "Deal Memo",
      getIcon: props => breadcrumbIcon(props),
    },
    {
      to: "/estimate",
      label: "Estimate",
      getIcon: props => breadcrumbIcon(props),
    },
    {
      to: "/shoot",
      label: "Shoot " + date,
      getIcon: props => breadcrumbIcon(props),
    },
    {
      to: "/bill-approval",
      label: "Bill Approval",
      getIcon: props => breadcrumbIcon(props),
    },
    {
      to: "/invoice",
      label: "Invoice",
      getIcon: props => breadcrumbIcon(props),
    },
  ]

  const breadcrumbIcon = props => {
    if (props.done) {
      return (
        <CheckCircleIcon
          style={{
            color: "#41B25B",
            marginLeft: "20px",
          }}
        />
      )
    } else if (
      (props.self.label.includes("Shoot") ? "Shoot" : props.self.label) ===
      generalData.billing_step_name
    ) {
      return (
        <FiberManualRecordTwoToneIcon
          style={{
            fontSize: "30px",
            color: "#41B25B",
            marginLeft: "20px",
          }}
        />
      )
    } else {
      return (
        <RadioButtonUncheckedIcon
          style={{
            color: "grey",
            marginLeft: "20px",
          }}
        />
      )
    }
  }

  // disabled indicators for Continue to Estimate & Continue to Invoice buttons
  const continueToEstimateDisabled = useMemo(
    //if true, button is disabled
    //if false, should allow to go next step
    () => {
      if (usersRolesArray.length) {
        if (
          usersRolesArray.filter(
            x =>
              !x.user_status ||
              x.user_status === "sent" ||
              x.user_status === "unsent"
          ).length > 0
        ) {
          return true
        }
        return false
      }
      return true
    },
    [usersRolesArray]
  )
  const estimateSent = useMemo(
    () => {
      if (generalData) {
        return Boolean(generalData.estimate_sent)
      }
    },
    [generalData]
  )

  const estimateAccepted = useMemo(
    () => {
      if (generalData) {
        return Boolean(generalData.estimate_accepted)
      }
    },
    [generalData]
  )
  const continueToInvoiceDisabled = useMemo(
    //if true, button is disabled
    //if false, should allow to go next step
    () => {
      if (usersRolesArray.length) {
        if (
          usersRolesArray.filter(x => x.user_status !== "approved").length > 0
        )
          return true
      }
      return false
    },
    [usersRolesArray]
  )

  const advanceStep = currentStep => {
    const stepData = {
      billing_step: currentStep,
      direction: "next",
    }
    dispatch(updateDealMemoBillingStep(stepData, shootId))
      .then(res => {
        if (res.data.step !== 4) {
          const newPage = res.data.step_name.replace(/\s+/g, "-").toLowerCase()
          props.history.push(`/shoots/${shootId}/billing/${newPage}`)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const handleAdvanceStep = breadcrumb => {
    if (
      generalData.billing_step !== 4 &&
      (Boolean(generalData.full_paid) ||
        Boolean(generalData.first_paid && generalData.second_paid))
    ) {
      advanceStep(3) //makes "Done", marks all subcategories and
      return breadcrumb
    } else {
      switch (breadcrumb) {
        case "/estimate":
          if (!continueToEstimateDisabled && generalData.billing_step === 0) {
            advanceStep(generalData.billing_step)
          }
          break
        case "/bill-approval":
          if (
            (estimateSent || estimateAccepted) &&
            generalData.billing_step === 1
          ) {
            advanceStep(generalData.billing_step)
          }
          break
        case "/invoice":
          if (!continueToInvoiceDisabled && generalData.billing_step === 2) {
            advanceStep(generalData.billing_step)
          }
          break
        default:
          return breadcrumb
      }
    }
  }

  return (
    <Breadcrumbs aria-label="breadcrumb" separator="">
      {/* <Tabs
        value="0"
        indicatorColor="secondary"
        textColor="inherit"
        TabIndicatorProps={{ style: { display: "none" } }}
      > */}
      <Box display="flex" flexDirection="row" justifyContent="flex-start">
        {breadcrumbPaths.map((breadcrumb, i) => {
          return breadcrumb.to === "/shoot" ? (
            <Button
              key={breadcrumb.to}
              color="inherit"
              variant="contained"
              disabled
              style={
                props.location.pathname === props.match.url + breadcrumb.to
                  ? CurrentPageStyle
                  : AfterStyles
              }
              value="0"
            >
              <Typography
                style={{
                  display: "flex",
                  whiteSpace: "nowrap",
                  overflow: "nowrap",
                }}
              >
                {breadcrumb.label}
              </Typography>
              {breadcrumb.getIcon({
                ...props,
                self: breadcrumb,
                done: isTheShootToday,
              })}
            </Button>
          ) : (
            <Button
              // if disabled to estimate or invoice is true, onclick else null? or to={}
              key={breadcrumb.to}
              onClick={() => handleAdvanceStep(breadcrumb.to)}
              to={`${props.match.url}${breadcrumb.to}`}
              component={Link}
              color="inherit"
              disableFocusRipple
              variant="contained"
              style={
                props.location.pathname === props.match.url + breadcrumb.to
                  ? CurrentPageStyle
                  : AfterStyles
              }
              value="0"
            >
              <Typography
                style={{
                  display: "flex",
                  whiteSpace: "nowrap",
                  overflow: "nowrap",
                }}
              >
                {breadcrumb.label}
              </Typography>
              {breadcrumb.getIcon({
                ...props,
                self: breadcrumb,
                done: done[i],
              })}
              {((breadcrumb.label === "Estimate" ||
                breadcrumb.label === "Invoice") &&
                hasNotifications(clientArray)) ||
              (((breadcrumb.label === "Deal Memo" ||
                breadcrumb.label === "Bill Approval") &&
                hasNotifications(crewArray)) ||
                (breadcrumb.label === "Invoice" &&
                  hasNotifications(invoiceArray))) ? (
                <FiberManualRecordIcon
                  style={{
                    fontSize: "17px",
                    color: "#F04031",
                    position: "absolute",
                    top: "-8",
                    right: "-8",
                  }}
                />
              ) : null}
            </Button>
          )
        })}
      </Box>
      {/* </Tabs> */}
    </Breadcrumbs>
  )
}
export default withRouter(PageBreadcrumbs)
